import { Feedback, MessageContentType, StreamItem } from '@/interfaces/chat';
import request from '@/utils/request';
export interface DtoListImNotifySettingResp {
  settings?: DtoImNotifySettingResp[];
  type?: string;
  voice?: number;
}

export interface DtoUpdateImNotifySettingReq {
  customer_type?: string;
  enabled?: boolean;
  id: number;
  scope?: string;
  setting_key?: string;
}

export interface DtoBatchUpdateImNotifySettingReq {
  settings: DtoUpdateImNotifySettingReq[];
  voice?: number;
}

export interface DtoImNotifySettingResp {
  customer_type?: string;
  enabled?: boolean;
  id?: number;
  scope?: string;
  setting_key?: string;
}
export interface GetMessageListParams {
  customerId: string;
  limit: number;
  sendAtLte?: number;
  idLt?: string;
  sendAtGte?: number;
  idGt?: string;
}
export interface LocateMessageParams {
  customerId: string;
  limit: number;
  msgId: string;
  sendAt?: number;
}

export const getMessageList = (data: GetMessageListParams) => {
  return request<StreamItem[]>({
    url: '/v1/im/message/list',
    method: 'POST',
    data,
  });
};

export const locateMessage = (data: LocateMessageParams) => {
  return request<StreamItem[]>({
    url: '/v1/im/message/locate',
    method: 'POST',
    data,
  });
};

export const sendMessage = (data: {
  customerId: string;
  contentType: MessageContentType;
  content: string;
  repliedMsgId?: string;
}) => {
  return request<{ id: string }>({ url: '/v1/im/message/send', method: 'POST', data });
};

export const withdrawMessage = (id: string) => {
  return request({ url: '/v1/im/message/withdraw', method: 'POST', data: { id } });
};

export const messageFeedback = (data: {
  id: string;
  feedback: Feedback;
  reason?: string;
  recommend?: string;
}) => {
  return request({ url: '/v1/im/message/feedback', method: 'POST', data });
};

export const previewStart = (subSourceId: string, source: string) => {
  return request<{ convId: string }>({
    url: '/v1/im/preview/start',
    method: 'POST',
    data: { subSourceId, source },
  });
};

// 预览会话(ws)
export const previewChat = (data: {
  content: string;
  contentType: MessageContentType;
  type?: string;
  convId: string;
  subSourceId: string;
  source?: string;
}) => {
  return request<{ convId: string }>({
    url: '/v1/im/preview/chat-ws',
    method: 'POST',
    data,
  });
};

export const restartPreview = (data: { convId: string; subSourceId: string }) => {
  return request<{ convId: string }>({
    url: '/v1/im/preview/restart',
    method: 'POST',
    data,
  });
};

export const exitPreview = (convId: string) => {
  return request({
    url: '/v1/im/preview/exit',
    method: 'POST',
    data: { convId },
  });
};

export const getImNotifySetting = () => {
  return request<DtoListImNotifySettingResp>({
    url: '/v1/im-notify/setting/list',
    method: 'POST',
  });
};

export const updateImNotifySetting = (data: DtoBatchUpdateImNotifySettingReq) => {
  return request<DtoBatchUpdateImNotifySettingReq>({
    url: '/v1/im-notify/setting/update',
    method: 'POST',
    data,
  });
};
